import React, { ReactNode, CSSProperties } from 'react';

interface IProps {
	children: ReactNode | ReactNode[],
	className?: string,
	style?: CSSProperties
}

/** Creates a div with classname row */
function LayoutRow(props: IProps) {
	let className = 'row';
	if (props.className) className += ' ' + props.className;

	return (
		<div className={className} style={props.style} >
			{props.children}
		</div>
	);
};

export default LayoutRow;